import { render } from "./HeaderVue.vue?vue&type=template&id=494c36d3&scoped=true"
import script from "./HeaderVue.vue?vue&type=script&lang=js"
export * from "./HeaderVue.vue?vue&type=script&lang=js"

import "./HeaderVue.vue?vue&type=style&index=0&id=494c36d3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494c36d3"]])

export default __exports__